import { useState } from "react";
import {
  FestivalMainInterviewGrid,
  FestivalMainInterviewHeader,
  FestivalMainInterviewItem,
  FestivalMainInterviewItemText,
  FestivalMainInterviewTop,
  FestivalMainInterviewTopText,
  FestivalMainInterviewWrapper,
} from "./style";
import DropBox from "../../../../../../../components/drop-box";
import RabbitFestivalMainInterviewSkeleton from "./skeleton";
import { FestivalSkeletonWhiteBox } from "../../../../style/skeleton";
import { useRabbitFestivalContext } from "../../../../hooks/festival-context";
import { RabbitFestivalPage } from "../../../../hooks/use-festival-tab";
import { NewsResponse } from "../../../../../../../api/news";
import { getYearList } from "../../../../../../../utils/date";

const RabbitFestivalMainInterview = () => {
  const [isYearOpen, setIsYearOpen] = useState(false);
  const {
    setFestivalPage,
    setInterviewId,
    setInterview,
    interviewList,
    topInterview,
    year,
    setYear,
    interviewIsFirst: isFirst,
    interviewLoading: loading,
  } = useRabbitFestivalContext();

  const handleClick = (item?: NewsResponse) => {
    if (!item) return;
    setInterview(null);
    setInterviewId(item.id || 0);
    setFestivalPage(RabbitFestivalPage.INTERVIEW);
  };

  return (
    <FestivalMainInterviewWrapper>
      <div className="title">인터뷰</div>
      {isFirst ? (
        <FestivalSkeletonWhiteBox height="210px" width="100%" radius="8px" />
      ) : (
        <FestivalMainInterviewTop onClick={() => handleClick(topInterview)}>
          <FestivalMainInterviewTopText>
            <div className="title">
              RABBIT
              <br />
              FESTIVAL
            </div>
            <div className="name">{topInterview?.mainTitle}</div>
          </FestivalMainInterviewTopText>
          {topInterview?.mainCoverImageUrl && (
            <img src={topInterview?.mainCoverImageUrl} alt="user" />
          )}
        </FestivalMainInterviewTop>
      )}
      <FestivalMainInterviewHeader>
        <div className="title">지난 인터뷰</div>
        <DropBox
          value={year}
          setValue={setYear}
          label={"년"}
          setIsOpen={setIsYearOpen}
          isOpen={isYearOpen}
          option={getYearList()}
        />
      </FestivalMainInterviewHeader>
      {loading ? (
        <RabbitFestivalMainInterviewSkeleton />
      ) : (
        <FestivalMainInterviewGrid>
          {interviewList.map((item, i) => (
            <FestivalMainInterviewItem
              key={i}
              onClick={() => handleClick(item)}
            >
              <FestivalMainInterviewItemText>
                <div className="title">
                  {item?.year}.{item?.month}
                </div>
                <div className="name">{item?.mainTitle}</div>
              </FestivalMainInterviewItemText>
              {item?.mainCoverImageUrl && (
                <img src={item?.mainCoverImageUrl} alt="user" />
              )}
              <div className="back" />
            </FestivalMainInterviewItem>
          ))}
        </FestivalMainInterviewGrid>
      )}
    </FestivalMainInterviewWrapper>
  );
};

export default RabbitFestivalMainInterview;
